// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Top level */
.Navbar_navbar__SW0hx {
    /* Between both: information and menu */
    display: flex;
    flex-direction: row;
    padding: 1em;
    justify-content: space-between;
}

/* Second level */

.Navbar_menu__N30DZ {
    /* Between image and nav items */
    display: flex;
    flex-direction: row;
}

.Navbar_information__7tSl1 {
    display: flex;
    flex-direction: column;
    margin-right: 2em;
    justify-content: center;
    font-weight: bold;
}

/* Information Right side of navbar*/
.Navbar_infoChild__N6TBz {
    display: flex;
    flex-direction: row;
}

.Navbar_information__7tSl1 span {
    font-weight: normal;
}

/* Menu and logo left side of navbar */
.Navbar_navbar__SW0hx ul {
    /* Between li items */
    display: flex;
    flex-direction: row;
    padding: 0;
    align-items: center;

}

.Navbar_navbar__SW0hx li {
    text-decoration: underline;
    text-underline-offset: 0.3em;
    font-weight: bold;
    list-style: none;
    margin-left: 1em;
    cursor: pointer;
}

.Navbar_navbar__SW0hx li:hover {
    color: #03171A;
}

.Navbar_link__AWrBc {
    color: white;
    list-style: none;
    display: inline-block;
    position: relative;
    text-decoration: underline;
    text-underline-offset: 0.3em;
    font-weight: bold;
    cursor: pointer;
}

.Navbar_link__AWrBc:hover {
    color: #03171A;
}

/* Width */

@media (min-width: 1600px) {
    .Navbar_information__7tSl1 span {
        font-size: 15px;
    }

    .Navbar_navbar__SW0hx li {
        font-size: 20px;
    }

    .Navbar_link__AWrBc {
        font-size: 20px;
    }
}

@media (min-width: 950px) and (max-width: 1599px) {
    .Navbar_information__7tSl1 span {
        font-size: 12px;
    }

    .Navbar_navbar__SW0hx li {
        font-size: 15px;
    }

    .Navbar_link__AWrBc {
        font-size: 15px;
    }
}

@media (min-width: 820px) and (max-width: 949px){
    .Navbar_information__7tSl1 span {
        font-size: 12px;
    }

    .Navbar_navbar__SW0hx li {
        font-size: 15px;
    }

    .Navbar_link__AWrBc {
        font-size: 15px;
    }
}

@media (min-width: 700px) and (max-width: 819px){
    .Navbar_information__7tSl1 span {
        font-size: 10px;
    }

    .Navbar_navbar__SW0hx li {
        font-size: 12px;
    }

    .Navbar_link__AWrBc {
        font-size: 12px;
    }
}

@media (min-width: 500px) and (max-width: 699px){

    .Navbar_information__7tSl1 span {
        font-size: 8px;
    }

    .Navbar_navbar__SW0hx li {
        font-size: 10px;
    }

    .Navbar_link__AWrBc {
        font-size: 10px;
    }

    .Navbar_information__7tSl1 label {
        font-size: 12px;
    }
}

@media (max-width: 499px) {

    .Navbar_navbar__SW0hx {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .Navbar_information__7tSl1 img{
        height: 15px;
        width: 15px;
    }

    .Navbar_information__7tSl1 span {
        font-size: 8px;
    }

    .Navbar_navbar__SW0hx li {
        font-size: 10px;
    }

    .Navbar_link__AWrBc {
        font-size: 10px;
    }

    .Navbar_information__7tSl1 label {
        font-size: 12px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/navbar/Navbar.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;AAClC;;AAEA,iBAAiB;;AAEjB;IACI,gCAAgC;IAChC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sCAAsC;AACtC;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,mBAAmB;;AAEvB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;IAC1B,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,UAAU;;AAEV;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["/* Top level */\n.navbar {\n    /* Between both: information and menu */\n    display: flex;\n    flex-direction: row;\n    padding: 1em;\n    justify-content: space-between;\n}\n\n/* Second level */\n\n.menu {\n    /* Between image and nav items */\n    display: flex;\n    flex-direction: row;\n}\n\n.information {\n    display: flex;\n    flex-direction: column;\n    margin-right: 2em;\n    justify-content: center;\n    font-weight: bold;\n}\n\n/* Information Right side of navbar*/\n.infoChild {\n    display: flex;\n    flex-direction: row;\n}\n\n.information span {\n    font-weight: normal;\n}\n\n/* Menu and logo left side of navbar */\n.navbar ul {\n    /* Between li items */\n    display: flex;\n    flex-direction: row;\n    padding: 0;\n    align-items: center;\n\n}\n\n.navbar li {\n    text-decoration: underline;\n    text-underline-offset: 0.3em;\n    font-weight: bold;\n    list-style: none;\n    margin-left: 1em;\n    cursor: pointer;\n}\n\n.navbar li:hover {\n    color: #03171A;\n}\n\n.link {\n    color: white;\n    list-style: none;\n    display: inline-block;\n    position: relative;\n    text-decoration: underline;\n    text-underline-offset: 0.3em;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.link:hover {\n    color: #03171A;\n}\n\n/* Width */\n\n@media (min-width: 1600px) {\n    .information span {\n        font-size: 15px;\n    }\n\n    .navbar li {\n        font-size: 20px;\n    }\n\n    .link {\n        font-size: 20px;\n    }\n}\n\n@media (min-width: 950px) and (max-width: 1599px) {\n    .information span {\n        font-size: 12px;\n    }\n\n    .navbar li {\n        font-size: 15px;\n    }\n\n    .link {\n        font-size: 15px;\n    }\n}\n\n@media (min-width: 820px) and (max-width: 949px){\n    .information span {\n        font-size: 12px;\n    }\n\n    .navbar li {\n        font-size: 15px;\n    }\n\n    .link {\n        font-size: 15px;\n    }\n}\n\n@media (min-width: 700px) and (max-width: 819px){\n    .information span {\n        font-size: 10px;\n    }\n\n    .navbar li {\n        font-size: 12px;\n    }\n\n    .link {\n        font-size: 12px;\n    }\n}\n\n@media (min-width: 500px) and (max-width: 699px){\n\n    .information span {\n        font-size: 8px;\n    }\n\n    .navbar li {\n        font-size: 10px;\n    }\n\n    .link {\n        font-size: 10px;\n    }\n\n    .information label {\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 499px) {\n\n    .navbar {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        align-content: center;\n    }\n\n    .information img{\n        height: 15px;\n        width: 15px;\n    }\n\n    .information span {\n        font-size: 8px;\n    }\n\n    .navbar li {\n        font-size: 10px;\n    }\n\n    .link {\n        font-size: 10px;\n    }\n\n    .information label {\n        font-size: 12px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `Navbar_navbar__SW0hx`,
	"menu": `Navbar_menu__N30DZ`,
	"information": `Navbar_information__7tSl1`,
	"infoChild": `Navbar_infoChild__N6TBz`,
	"link": `Navbar_link__AWrBc`
};
export default ___CSS_LOADER_EXPORT___;
